// extracted by css-extract-rspack-plugin
export default {"stickyContainer":"peLkuSZwP03QvTmO","stickyButton":"JlHzxAue8vM8Gamx","slide-in-xl":"MXGNspyT0EbpF4Ct","stickyContent":"JjHessDc9jsgQkah","stickyArrowIcon":"sYklSGcit20dG25s"};